function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Master",
  stroke: "none",
  strokeWidth: 1.5,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons",
  transform: "translate(-40.000000, -223.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(40.000000, 223.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 16,
  height: 16
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.21417978,5.501337 L7.33322678,11.6825105 C7.50020754,11.8840273 7.743943,12 8.00048273,12 C8.25702246,12 8.50075792,11.8840273 8.66773868,11.6825105 L13.7867857,5.501337 C14.2753254,4.91133657 13.8702842,4 13.1195297,4 L2.87997084,4 C2.12921634,4 1.72417514,4.91133657 2.21417978,5.501337 Z",
  id: "Path",
  fill: "currentColor"
}))));

var SvgFilledChevronDown = function SvgFilledChevronDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilledChevronDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/filled-chevron-down.a7de7a5f.svg";
export { ForwardRef as ReactComponent };